import { createRoot } from 'react-dom/client';
import { activateGlobalProgressIndicator } from './common/utils/axiosProgressIndicator';
import ManagerApp from './containers/ManagerApp';
import './scss/main.scss';

activateGlobalProgressIndicator();
const container = document.getElementById('root')!
const root = createRoot(container);
root.render(<ManagerApp />);
